import { useState, forwardRef, useImperativeHandle, useEffect } from "react";
import { Alert, Box, Button, Checkbox, Divider, FormControlLabel, Grid, Radio, Switch, TextField, Tooltip, Typography, useTheme } from "@mui/material";
import { LocalInfo, newLocalInfo, CentralFrame } from "../../model/CollectiveAgreement";
import { ClickableIcon } from "../../components/ui/Icon";

interface LocalInfoFormProps {
    CentralFrame: CentralFrame;
    error?: string;
    autocomplete?: boolean; // toggle autocomplete, nice for managers
  }
  

export interface LocalInfoFormRef {
  valid: () => boolean;
  getItem: () => LocalInfo;
}

export const LocalInfoForm = forwardRef((props: LocalInfoFormProps, ref) => {
  const { error, autocomplete = true , CentralFrame} = props;
  const [LocalInfo, setLocalInfo] = useState<LocalInfo>(newLocalInfo());
  const [submitted, setSubmitted] = useState(false);

  const [touched, setTouched] = useState<{
    base: Record<string, boolean>;
  }>({
    base: {},
  });

  const valid = () => {
    let hasErrors = false;

    // Validate all base fields
    for (const key of Object.keys(LocalInfo) as (keyof LocalInfo)[]) {
      if (typeof LocalInfo[key] !== "object" && validateBaseField(key)) {
        hasErrors = true;
      }
    }

    setSubmitted(true);
    return !hasErrors;
  }

  const getItem = () => {
    return LocalInfo;
  }
  
  useImperativeHandle(ref, () => ({
    valid,
    getItem,
  }));

  const validateBaseField = (field: keyof LocalInfo): string => {
    if (field === "LAvgH") {
      if (LocalInfo.LAvgH == 0) return "LAvgH tom";
    }
    return ""; // No error
  };

  const handleBaseChange = (field: keyof LocalInfo, value: any) => {
    setLocalInfo((prev) => ({ ...prev, [field]: value }));
  };

  const handleBaseBlur = (field: keyof LocalInfo) => {
    setTouched((prev) => ({
      ...prev,
      base: { ...prev.base, [field]: true },
    }));
  };

  return (
    <form>
      <Grid container spacing={2}
        sx={{ justifyContent: "center", alignItems: "center" }}
      >
        {error && <Alert sx={{ width: '100%' }} severity="error">{error}</Alert>}

        <Grid item xs={12}>
          <TextField
            label="Navn"
            required
            fullWidth
            value={LocalInfo.LAvgH}
            onChange={(e) => handleBaseChange("LAvgH", e.target.value)}
            variant="outlined"
            type={"number"}
            error={validateBaseField("LAvgH") !== "" && (submitted || touched.base.LAvgH)}
            helperText={(submitted || touched.base.LAvgH) ? validateBaseField("LAvgH") : ""}
            onBlur={() => handleBaseBlur("LAvgH")}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Navn"
            required
            fullWidth
            value={LocalInfo.LLAM}
            onChange={(e) => handleBaseChange("LLAM", e.target.value)}
            variant="outlined"
            type={"number"}
            error={validateBaseField("LLAM") !== "" && (submitted || touched.base.LLAM)}
            helperText={(submitted || touched.base.LLAM) ? validateBaseField("LLAM") : ""}
            onBlur={() => handleBaseBlur("LLAM")}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Navn"
            required
            fullWidth
            value={LocalInfo.LUM}
            onChange={(e) => handleBaseChange("LUM", e.target.value)}
            variant="outlined"
            type={"number"}
            error={validateBaseField("LUM") !== "" && (submitted || touched.base.LUM)}
            helperText={(submitted || touched.base.LUM) ? validateBaseField("LUM") : ""}
            onBlur={() => handleBaseBlur("LUM")}
          />
        </Grid>
        {CentralFrame.guarantee_active && (
        <>
            <Grid item xs={12}>
              <TextField
                label="Navn"
                required
                fullWidth
                value={LocalInfo.MwG}
                onChange={(e) => handleBaseChange("MwG", e.target.value)}
                variant="outlined"
                type={"number"}
                error={validateBaseField("MwG") !== "" && (submitted || touched.base.MwG)}
                helperText={(submitted || touched.base.MwG) ? validateBaseField("MwG") : ""}
                onBlur={() => handleBaseBlur("MwG")}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Navn"
                required
                fullWidth
                value={LocalInfo.MwGT}
                onChange={(e) => handleBaseChange("MwGT", e.target.value)}
                variant="outlined"
                type={"number"}
                error={validateBaseField("MwGT") !== "" && (submitted || touched.base.MwGT)}
                helperText={(submitted || touched.base.MwGT) ? validateBaseField("MwGT") : ""}
                onBlur={() => handleBaseBlur("MwGT")}
              />
            </Grid>
        </>
        )}
        <Grid item xs={12}>
          <TextField
            label="Navn"
            required
            fullWidth
            value={LocalInfo.LLAD}
            onChange={(e) => handleBaseChange("LLAD", e.target.value)}
            variant="outlined"
            type={"number"}
            error={validateBaseField("LLAD") !== "" && (submitted || touched.base.LLAD)}
            helperText={(submitted || touched.base.LLAD) ? validateBaseField("LLAD") : ""}
            onBlur={() => handleBaseBlur("LLAD")}
          />
        </Grid>
      </Grid>
    </form>
  )
});